<template>
  <div class="menu-wrapper">
    <template v-for="item in leilist" >
      <router-link  :to="item.path" :key="item.meta.name" v-if="!item.children">
        <el-menu-item :index="item.path" :class="{'submenu-title-noDropdown':!isNest}"  @click="menuClik(item)">
          <i :class="item.meta.icon"></i>
          <span  slot="title">{{item.meta.title}}</span>
        </el-menu-item>
      </router-link>
      <el-submenu :index="item.meta.title||item.path" :key="item.meta.title" v-else>
        <template slot="title">
          <i  :class="item.meta.icon"></i>
          <span  slot="title">{{item.meta.title}}</span>
    </template>
        <template v-for="child in item.children">
          <router-link :to="child.path" :key="child.meta.title"   >
            <!-- -->
            <el-menu-item :index="child.path" @click="menuClik(child)">
              <img v-if="child.meta.title=='公众号管理'" src="../../../../assets/image/whitewe.png" alt="" style="margin-right: 10px;margin-left: 5px;">
              <i :class="child.meta.icon"></i>
              <span  slot="title" >{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      leilist:[],
    }
  },
  // mounted(){
  //   this.getlist()
  // },
  created(){
    this.getlist()
   
  },
  methods: {
    menuClik(val){
      if(val){
         localStorage.setItem("Menuids", val.id);
      }
    },
      getlist(){
      this.$api.get('/sys/permission/getUserPermissionByToken').then((res) => {
        if(res.data.success = true){
          console.log("菜单权限信息",res.data.result.menu)
          this.leilist=res.data.result.menu
        }
    })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue